//  Autore: Claude.
//  Iscrizione alla newsletter dal footer (issue #1433): il click non apre più un popup nostro,
//  blocca il default e notifica a GTM l'evento mc_subscribe, che apre il popup di MailChimp.

/** Click sul bottone "Iscriviti" del footer: push di mc_subscribe nel dataLayer. Autore: Claude. */
function btnIscrivitiNewsletter_Click(e) {
    e?.event?.preventDefault();

    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'mc_subscribe' });
    }
    catch (ex) {
        console.log(ex);
    }
}
